import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-e9eb849c"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "wrap"
};
var _hoisted_2 = { class: "content" };
var _hoisted_3 = { class: "title" };
var _hoisted_4 = { class: "title-rotate" };
var _hoisted_5 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", null, "请您在下方区域保持横屏签名（正楷）", -1); });
var _hoisted_6 = { class: "agree" };
var _hoisted_7 = /*#__PURE__*/ _createTextVNode(" 签字代表已经阅读和同意");
var _hoisted_8 = { class: "btn-box" };
var _hoisted_9 = /*#__PURE__*/ _createTextVNode("返回");
var _hoisted_10 = /*#__PURE__*/ _createTextVNode("重签");
var _hoisted_11 = /*#__PURE__*/ _createTextVNode("确认提交");
var _hoisted_12 = { class: "overlay-wrapper" };
import { ref } from "vue";
import VueEsign from "vue-esign";
import { requestQNToken } from "@/api";
import * as qiniu from "qiniu-js";
import { Toast } from "vant";
import InformedConsent from "@/components/informedConsent.vue";
import { useRouter } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'esign',
    emits: ["cancel", "ok"],
    setup: function (__props, _a) {
        var _this = this;
        var emit = _a.emit;
        var router = useRouter();
        var LoadingVisible = ref(false);
        var esign = ref();
        var resultImg = ref();
        var handleReset = function () {
            esign.value.reset();
        };
        var qiNiuToken = ref();
        var getQiNiuToken = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestQNToken().catch(function () { return Toast("系统错误-04"); })];
                    case 1:
                        res = _a.sent();
                        if (res.code === 200) {
                            qiNiuToken.value = res.data;
                        }
                        else {
                            Toast(res.message);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        getQiNiuToken();
        var handleGenerate = function () {
            LoadingVisible.value = true;
            esign.value
                .generate()
                .then(function (res) {
                var observable = qiniu.upload(dataURLtoFile(res), new Date().getTime(), qiNiuToken.value);
                var subscription = observable.subscribe({
                    complete: function (res) {
                        LoadingVisible.value = false;
                        resultImg.value = "https://image.liangjue.net/" + res.key;
                        console.log("上传成功", resultImg.value);
                        emit("ok", resultImg.value);
                    },
                });
            })
                .catch(function (err) {
                Toast("请签字");
                LoadingVisible.value = false;
                console.log(err);
            });
        };
        //将base64转换为文件
        function dataURLtoFile(dataurl) {
            var arr = dataurl.split(","), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        }
        var informedConsentVisible = ref(false);
        return function (_ctx, _cache) {
            var _component_van_icon = _resolveComponent("van-icon");
            var _component_van_nav_bar = _resolveComponent("van-nav-bar");
            var _component_van_button = _resolveComponent("van-button");
            var _component_van_loading = _resolveComponent("van-loading");
            var _component_van_overlay = _resolveComponent("van-overlay");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (!informedConsentVisible.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_van_nav_bar, {
                            title: "签字确认",
                            onClickLeft: _cache[0] || (_cache[0] = function ($event) { return (emit('cancel')); })
                        }, {
                            left: _withCtx(function () { return [
                                _createVNode(_component_van_icon, {
                                    color: "rgba(0,0,0,0.9)",
                                    name: "arrow-left",
                                    size: "24"
                                })
                            ]; }),
                            _: 1
                        }),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_unref(VueEsign), {
                                ref_key: "esign",
                                ref: esign,
                                width: 750,
                                height: 1750,
                                isCrop: true,
                                lineWidth: 6,
                                lineColor: "#000"
                            }, null, 512),
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _hoisted_5,
                                    _createElementVNode("p", _hoisted_6, [
                                        _hoisted_7,
                                        _createElementVNode("span", {
                                            style: { color: '#FF3DABA4' },
                                            onClick: _cache[1] || (_cache[1] = function ($event) { return (informedConsentVisible.value = true); })
                                        }, "《用户知情同意书》")
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_van_button, {
                                    style: { width: '2rem' },
                                    round: "",
                                    onClick: _cache[2] || (_cache[2] = function ($event) { return (emit('cancel')); })
                                }, {
                                    default: _withCtx(function () { return [
                                        _hoisted_9
                                    ]; }),
                                    _: 1
                                }),
                                _createVNode(_component_van_button, {
                                    round: "",
                                    style: _normalizeStyle({ width: '2rem', margin: '0 0.24rem' }),
                                    color: "#3DABA4",
                                    plain: "",
                                    onClick: handleReset
                                }, {
                                    default: _withCtx(function () { return [
                                        _hoisted_10
                                    ]; }),
                                    _: 1
                                }, 8, ["style"]),
                                _createVNode(_component_van_button, {
                                    style: { width: '2rem' },
                                    round: "",
                                    color: "#3DABA4",
                                    plain: "",
                                    onClick: handleGenerate
                                }, {
                                    default: _withCtx(function () { return [
                                        _hoisted_11
                                    ]; }),
                                    _: 1
                                })
                            ])
                        ]),
                        _createVNode(_component_van_overlay, {
                            show: LoadingVisible.value,
                            style: { zIndex: 100 }
                        }, {
                            default: _withCtx(function () { return [
                                _createElementVNode("div", _hoisted_12, [
                                    _createVNode(_component_van_loading, {
                                        color: "#0094ff",
                                        size: "24px",
                                        vertical: ""
                                    })
                                ])
                            ]; }),
                            _: 1
                        }, 8, ["show"])
                    ]))
                    : _createCommentVNode("", true),
                (informedConsentVisible.value)
                    ? (_openBlock(), _createBlock(InformedConsent, {
                        key: 1,
                        isVanPopup: true,
                        onCancel: _cache[3] || (_cache[3] = function ($event) { return (informedConsentVisible.value = false); })
                    }))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
